import styled, {css} from "styled-components"
import {PHONE} from "../global/media"

interface ContainerProps {
  bgColor?: string
}
export const Container = styled.div<ContainerProps>`
  display: flex;
  position: relative;
  align-items: center;
  height: 238px;
  overflow: hidden;

  ${({theme, bgColor}) => css`
    padding: 0 ${theme.spacing.two};
    ${bgColor && `background-color: ${bgColor};`}
  `}

  ${({theme}) => theme.mediaQueries.minWidthMedia.phoneLandscape`
    padding: 0 ${theme.spacing.five};
  `}
`

export const BackgroundImg = styled.div<{imgUrl: string; bgPosition?: string}>`
  ${({theme, imgUrl, bgPosition = "center"}) => css`
    z-index: -1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    background-size: cover;
    filter: brightness(0.4);
    background-repeat: no-repeat;
    background-position: ${bgPosition};
    background-image: linear-gradient(${theme.colors.secondary2}, ${theme.colors.primary2});
    ${imgUrl && `background-image: url("${imgUrl}");`}
  `}
`

export const HeroSliderSettings = {
  dots: true,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [{breakpoint: PHONE, settings: {arrows: false, draggable: true}}]
}
